import React, { type FC } from 'react'
import { Box, type SxProps, type Theme } from '@mui/material'

import { Translation } from '../../../../domain'

import { FormattedTranslation } from '../../Internationalization'
import { Button } from '../Button'

type ActionButtonsProps = Readonly<{
    onCancel: () => void
    onApply: () => void
    disabled: boolean
}>

const containerStyle: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 2,
}

export const ActionButtons: FC<ActionButtonsProps> = ({ onCancel, onApply, disabled }) => (
    <Box sx={containerStyle}>
        <Button size="medium" variant="secondary" onClick={onCancel} data-testid="cancel-button">
            <FormattedTranslation id={Translation.CANCEL} />
        </Button>

        <Button size="medium" variant="primary" onClick={onApply} disabled={disabled} data-testid="apply-button">
            <FormattedTranslation id={Translation.APPLY} />
        </Button>
    </Box>
)
